import { ArrowRightIcon, MapPinIcon } from "assets/icons";

export default function AddressCard() {
  return (
    <div className="shadow-block w-full border-[1px] border-primary-700 rounded-[16px] flex items-center px-4 py-4 sm:py-6 mt-2">
      <div className="flex-1 flex items-center">
        <div className="text-primary-700 mr-4">
          <MapPinIcon />
        </div>
        <div className="text-sm text-[#858585] font-medium">
          3, Jalan PJS 11/11, Bandar Sunway, 47500 Subang Jaya, Selangor
        </div>
      </div>
      <div className="h-[18px] w-[18px] text-[#858585]">
        <ArrowRightIcon />
      </div>
    </div>
  );
}
